
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileText, Camera, Plus } from "lucide-react";
import Header from "@/components/Header";
import PullToRefreshIndicator from "@/components/PullToRefreshIndicator";
import { usePullToRefresh } from "@/hooks/use-pull-to-refresh";
import reportingIllustration from "@/assets/reporting-illustration.jpg";

const ReportGrievance = () => {
  const navigate = useNavigate();

  // Simple pull to refresh that navigates back
  const pullToRefresh = usePullToRefresh({
    onRefresh: async () => {
      // Just refresh the page state
      window.location.reload();
    },
  });

  const goToAddCase = () => {
    navigate("/add-case");
  };

  const goToAddPhoto = () => {
    navigate("/add-photo");
  };

  return (
    <div ref={pullToRefresh.containerRef} className="flex flex-col min-h-[100dvh] bg-background overflow-auto">
      <PullToRefreshIndicator
        isVisible={pullToRefresh.shouldShowIndicator}
        isRefreshing={pullToRefresh.isRefreshing}
        pullDistance={pullToRefresh.pullDistance}
      />
      
      <Header title="Report a Grievance" showBackButton />

      <main className="flex-1 pt-16 px-4 flex flex-col">
        <div className="text-center my-8">
          <h1 className="text-2xl font-bold mb-2">Mining Grievance Reporter</h1>
          <p className="text-muted-foreground">
            Report issues with mining operations in your community
          </p>
        </div>

        {/* Reporting illustration */}
        <div className="flex justify-center mb-8">
          <div className="w-64 h-48 animate-fade-in">
            <img
              src={reportingIllustration}
              alt="Person reporting mining grievance"
              className="w-full h-full object-cover rounded-lg opacity-80 hover:opacity-100 transition-opacity duration-300"
            />
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center gap-6 max-w-md mx-auto w-full">
          <Button
            onClick={goToAddCase}
            size="lg"
            className="h-auto py-6 gap-4 text-lg"
          >
            <FileText size={24} />
            File a New Grievance
          </Button>

          {/*  <Button 
            onClick={goToAddPhoto}
            variant="outline"
            size="lg"
            className="h-auto py-6 gap-4 text-lg"
          >
            <Camera size={24} />
            Add Supporting Photo
          </Button> */}

          <div className="text-center mt-8">
            <p className="text-sm text-muted-foreground mb-2">
              Your voice matters in protecting our communities and environment.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReportGrievance;
